module.exports = __webpack_public_path__ + "static/media/08.74b7579d.jpg";